import styled from "styled-components";

export const SidebarDiv = styled.nav`
  flex: 1;
  border-right: 0.5px solid lightgray;
  min-height: 100vh;
  background-color: #660099;

  .top {
    min-height: 62px;

    .logo {
      cursor: pointer;
      text-align: center;
      img {
        margin: 1rem 0;
        width: 4rem;
        -webkit-filter: brightness(0) invert(1);
        filter: brightness(0) invert(1);
      }
    }
  }

  hr {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  .center {
    margin-top: 1rem;

    ul {
      list-style: none;
      padding: 0;
      padding-left: 1rem;

      .title {
        font-size: 0.7rem;
        font-weight: bold;
        padding-bottom: 0.5rem;
        color: #ece8ff;
      }

      li .page {
        padding: 0.3rem 0rem;
        margin-bottom: 0.5rem;
        display: flex;
        align-items: center;
        gap: 0.3rem;
        cursor: pointer;
        text-decoration: none;
        color: #ece8ff;

        &:hover {
          /* background-color: #ece8ff; */
        }

        .icon {
          font-size: 1.1rem;
          color: #ece8ff;
        }

        span {
          font-size: 0.7rem;
          font-weight: 600;
          color: #ece8ff;
        }
      }
    }
  }
`;

export const DropDown = styled.div`
  .dp {
    padding: 0.3rem 0rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 0.5rem;

    &:hover {
      color: #fff;
    }
  }

  .dp-page {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      color: #ece8ff;
    }

    .icon {
      font-size: 1.1rem;
      color: #7451f8;
      color: #ece8ff;
    }

    span {
      font-size: 0.7rem;
      font-weight: 600;
      color: #ece8ff;
    }
  }

  .icon {
    font-size: 1.1rem;
    color: #7451f8;
  }
`;
